import { Result } from './model';
export var withErrorMessage = function (sanitizer, expected) {
    return function (value, path) {
        var result = sanitizer(value, path);
        if (Result.isError(result)) {
            return Result.error([{ path: path, expected: expected }]);
        }
        else {
            return result;
        }
    };
};
